import React from "react"
import Img from "gatsby-image"
import CardTest from "../card-test/card-test"
import "./cards-subcategory.scss"
import { datalayerProduct } from "../../../shared/utils/datalayerProducts"
import { encryptUserInfo } from "../../../shared/utils/encryptUserInfo"
import { pushDataLayerEvent } from "../../../shared/utils/metricManagementUtil"
import { removeDoubleSlash } from "../../../shared/utils/urlUril"

const CardsSubcategory = ({
  subcategories,
  category,
  onClickReference,
  descubreProductoIdeal,
  haveRelease,
}) => {
  const userInfoEncrypt= encryptUserInfo()
  return (
    <>
      <div
        className={`f-cards-subcategory ${
          !haveRelease ? "f-no-have-release" : ""
        } `}
      >
        {subcategories.map((subcategory, index) => {
          return (
            <a
              href={removeDoubleSlash("/productos/" + category + "/" + (subcategory.slug === "copa-menstrual/" ? "copa-menstrual/v-cup/" : subcategory.slug === "toallas-reutilizables/" ? "toallas-reutilizables/toalla-reutilizable/" : subcategory.slug))}
              className={`f-subcategory-card  ${
                category === "v-confident" ? "f-v-confident-card" : ""
              }`}
              key={`${category}-${subcategory.titulo}-${index}`}
              onClick={() => {
                pushDataLayerEvent({
                  event: "Interacciones - Menu",
                  category: category,
                  action: "click",
                  label: subcategory.titulo,
                  sub_category: subcategory.titulo,
                  location: window.location.href,
                  user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
                  log_status: userInfoEncrypt.log_status,
                })
                datalayerProduct({subCategory: category, label: subcategory.titulo})
              }}
            >
              <Img
                className="f-subcategory-card__img"
                fixed={subcategory.imagenSubcategoria.fixed}
                alt={subcategory.imagenSubcategoria.description}
              />
              <h3 className="f-subcategory-card__title">
                {subcategory.titulo}
              </h3>
            </a>
          )
        })}
      </div>
      {descubreProductoIdeal.descripcionProductoIdeal && (
        <CardTest
          onClickReference={onClickReference}
          color={category}
          descubreProductoIdeal={descubreProductoIdeal}
        />
      )}
    </>
  )
}

export default CardsSubcategory
